/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_MergingInputs */



/**
* | output |
* | --- |
* | "Merging..." |
*
* @param {Vekn_MergingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_merging = /** @type {((inputs?: Vekn_MergingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_MergingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fusion...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fusionando...")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Mesclando...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Unione...")
	return /** @type {LocalizedString} */ ("Merging...")
});